import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Authorities, AuthoritiesServer, LoginResponse, LoginUser} from "../../core/login/interface";
import moment from "moment/moment";
import {defaultLocalCode} from "../../core/localization/defaults";
import {LocaleType} from "../../core/localization/intertace";
import UserRole from "../../core/app/enums/UserRole";
import {defaultAuthorities} from "../../core/login/defaults";
import {defaultSubProjectName} from "../../containers/login/interface";

export interface AuthModel {
    token: string,
    refreshToken: string,
    localeCode:LocaleType,
    user?:LoginUser,
    authorities?:Authorities
    lastCheckTime:number,
    organizationId:number,
    organizationName:string,
    subProject?:string,
}
export const  defaultAuthModel:AuthModel={
    token : "",
    refreshToken: "",
    localeCode: defaultLocalCode,
    lastCheckTime:0,
    organizationId:0,
    user:{userId:0,surname:"",name:"",username:"",tokenId:""},
    authorities:defaultAuthorities,
    organizationName:'',
    subProject:'mino'

}
const getToken = () => {
    const ls = localStorage.getItem('token');
    if(ls !== null){
        return ls as string;
    }
    return '' as string;
};
const getRefreshToken = () => {
    const ls = localStorage.getItem('refreshToken');
    if(ls !== null){
        return ls as string;
    }
    return '' as string;
};

export const getSubProject = () => {
    const ls = localStorage.getItem('subproject');
    if(ls !== null){
        return ls as string;
    }
    return defaultSubProjectName as string;
};
const getUser = ():LoginUser => {
    const ls = localStorage.getItem('user');
    if(ls !== null){
        return JSON.parse(ls) as LoginUser;
    }
    return {username:"*",userId:0,name:"",surname:""} as LoginUser;
};
const getOrganizationId = ():number => {
    const ls = localStorage.getItem('organization');
    if(ls !== null){
        return Number.parseInt(ls.toString());
    }
    return 0;
};
const getOrganizationName = ():string => {
    const ls = localStorage.getItem('organizationName');
    if(ls !== null){
        return ls.toString();
    }
    return "";
};
const getAuthorities = ():Authorities => {
    const ls = localStorage.getItem('authorities');
    let tempValue:AuthoritiesServer|undefined= undefined;
    if(ls !== null){
        tempValue = JSON.parse(ls) as AuthoritiesServer;
    }
    if(tempValue){
        return {accessPermissions:tempValue.accessPermissions
            ,roles:tempValue.roles.map(value => {
                return UserRole.InstanceWithFieldName(value);
            })}
    }else{
        return {accessPermissions:[],roles:[]} as Authorities;
    }

};

const initialState:AuthModel = {
    token: getToken(),
    refreshToken: getRefreshToken(),
    subProject:getSubProject(),
    user:getUser(),
    authorities:getAuthorities(),
    localeCode:defaultLocalCode,
    lastCheckTime:0,
    organizationId:getOrganizationId(),
    organizationName:getOrganizationName()
}

export const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        setOrganizationId: (state, action: PayloadAction<number>) => {
            state.organizationId = action.payload;
            localStorage.setItem('organization', action.payload.toString());
        },

        setOrganization: (state, action: PayloadAction<{ id:number,name:string }>) => {
            state.organizationId = action.payload.id;
            state.organizationName = action.payload.name;
            localStorage.setItem('organizationName', action.payload.name);
            localStorage.setItem('organization', action.payload.id.toString());
        },
        setSubProject: (state, action: PayloadAction<string>) => {
            state.subProject = action.payload;
            localStorage.setItem('subproject', action.payload.toString());
        },
        setAuthorities: (state, action: PayloadAction<Authorities>) => {
            state.authorities = action.payload;
        },

        login: (state, action: PayloadAction<LoginResponse>) => {
            const token = action.payload.accessToken;
            // Organizasyon değişikliğinde sunucu yeni yenileme token'ı vermez, eldeki korunur
            const refreshToken = action.payload.refreshToken || localStorage.getItem('refreshToken') || '';
            localStorage.setItem('token', action.payload.accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            localStorage.setItem('user', JSON.stringify(action.payload.user));
            localStorage.setItem('lastUser', action.payload.user.username);
            localStorage.setItem('authorities', JSON.stringify(action.payload.authorities));
            localStorage.setItem('organizationName', action.payload.organizationName);
            return  {
                localeCode: action.payload.locale,
                token:token,
                lastCheckTime: moment.now(),
                authorities:{accessPermissions:action.payload.authorities.accessPermissions
                ,roles:action.payload.authorities.roles.map(value => {
                    return UserRole.InstanceWithFieldName(value);
                    })},
                user: action.payload.user,
                organizationName:action.payload.organizationName,
                refreshToken:refreshToken,

            } as AuthModel;
        },
        setCheckTime: (state, action: PayloadAction<number>) => {
            state.lastCheckTime = action.payload;
        },
        logout: () => {
            const languageTag = localStorage.getItem('languageTag')
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('user')
            localStorage.removeItem('authorities')
            localStorage.removeItem('organizationName')
            return  {
                token: '',
                localeCode: languageTag ?? defaultLocalCode,
                lastCheckTime: 0,
                refreshToken:'',
                user: undefined,
                authorities:undefined,

            } as AuthModel;

        },


    }
})

 export const { login, logout,setCheckTime,setOrganizationId,setOrganization ,setSubProject} = authSlice.actions;

export default authSlice.reducer;
